<template>
  <div class="support">
    <!-- 右下角只保留 Intercom 自己的气泡（logo + 客服会话），与经典版一致。
         本抽屉（帮助指南等）从左侧导航的"帮助与支持"打开。 -->
    <el-drawer :visible.sync="visible" :with-header="false" size="400px" :append-to-body="true">
      <div class="support-panel">
        <!-- 顶栏 -->
        <div class="support-panel__top">
          <div class="support-panel__title">
            <span class="support-panel__title-main">{{ $t("support.title") }}</span>
            <span class="support-panel__title-sub">{{ $t("support.subtitle") }}</span>
          </div>
          <button type="button" class="support-panel__close" @click="visible = false">
            <i class="el-icon-close"></i>
          </button>
        </div>

        <div class="support-panel__body">
          <!-- 支持时间与联系方式 -->
          <div class="support-hours">
            <div class="support-hours__title">{{ $t("support.hoursTitle") }}</div>
            <div class="support-hours__line"><i class="el-icon-user"></i> {{ $t("support.liveHours") }}</div>
            <div class="support-hours__line"><i class="el-icon-cpu"></i> {{ $t("support.aiHours") }}</div>
            <div class="support-hours__line">
              <i class="el-icon-phone-outline"></i> {{ $t("support.phoneLabel") }}:
              <a :href="'tel:' + $t('support.phone')">{{ $t("support.phone") }}</a>
            </div>
            <div class="support-hours__line">
              <i class="el-icon-message"></i> {{ $t("support.emailLabel") }}:
              <a :href="'mailto:' + $t('support.email')">{{ $t("support.email") }}</a>
            </div>
          </div>

          <!-- 在线聊天：新版界面不显示右下角气泡，聊天从这里打开 -->
          <button type="button" class="support-opt" @click="openChatNow">
            <span class="support-opt__icon support-opt__icon--chat"><i class="el-icon-chat-dot-round"></i></span>
            <span class="support-opt__text">
              <span class="support-opt__title">{{ $t("support.chatTitle") }}</span>
              <span class="support-opt__sub">{{ $t("support.chatSub") }}</span>
            </span>
            <i class="el-icon-arrow-right support-opt__chev"></i>
          </button>

          <!-- 指南与帮助：直达 help.vapetm.com 帮助中心（搜索 + 常用指南深链） -->
          <button type="button" class="support-opt" @click="openGuides">
            <span class="support-opt__icon support-opt__icon--guides"><i class="el-icon-notebook-2"></i></span>
            <span class="support-opt__text">
              <span class="support-opt__title">{{ $t("support.guidesTitle") }}</span>
              <span class="support-opt__sub">{{ $t("support.guidesSub") }}</span>
            </span>
            <i class="el-icon-arrow-right support-opt__chev"></i>
          </button>

          <div class="support-guides">
            <el-input
              v-model="guideQuery"
              size="small"
              clearable
              prefix-icon="el-icon-search"
              :placeholder="$t('support.guidesSearchPh')"
              @keyup.enter.native="searchGuides"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchGuides"></el-button>
            </el-input>
            <div class="support-guides__label">{{ $t("support.guidesBrowse") }}</div>
            <a v-for="g in guideLinks" :key="g.url" class="support-guides__link" :href="g.url" target="_blank" rel="noopener" @click.prevent="openArticle(g)">
              <i class="el-icon-document"></i>
              <span class="support-guides__link-text">{{ g.label }}</span>
              <i class="el-icon-arrow-right"></i>
            </a>
          </div>

          <div class="support-note"><i class="el-icon-time"></i> {{ $t("support.replyNote") }}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  // 「帮助与支持」抽屉：支持时间、电话邮箱、在线聊天、帮助指南与文章搜索。
  // 新版界面隐藏了 Intercom 右下角气泡，在线聊天只从这里进入。
  import { HELP_CENTER, openChat, showArticle, showHelpSpace } from "@/utils/intercomHelp";

  export default {
    name: "SupportHub",
    data() {
      return {
        guideQuery: "",
        // 常用指南（Intercom 文章 ID 应用内展示；url 为消息器不可用时的网页回退）
        guideLinks: [
          { label: "Understanding transaction statuses", articleId: 10560495, url: HELP_CENTER + "articles/10560495-understanding-transaction-status-on-vapetm-software" },
          { label: "How to issue a refund on Nayax", articleId: 12070502, url: HELP_CENTER + "articles/12070502-how-to-issue-a-refund-on-nayax" },
          { label: "Refunds and failed delivery", articleId: 10105882, url: HELP_CENTER + "articles/10105882-refunds-and-failed-delivery" },
          { label: "Machine connectivity problems", articleId: 11111609, url: HELP_CENTER + "articles/11111609-machine-connectivity-problems" },
          { label: "Add products to your library", articleId: 10253371, url: HELP_CENTER + "articles/10253371-machine-setup-add-product-to-your-library" },
          { label: "Connect your machine to Wi-Fi", articleId: 10377326, url: HELP_CENTER + "articles/10377326-how-to-connect-your-vapetm-machine-to-wi-fi" },
          { label: "Getting started with the mobile app", articleId: 15674073, url: HELP_CENTER + "articles/15674073-getting-started-with-the-vtm-vending-mobile-app" }
        ]
      };
    },
    computed: {
      visible: {
        get() {
          return this.$store.state.supportVisible;
        },
        set(val) {
          this.$store.commit("set", { supportVisible: val });
        }
      }
    },
    methods: {
      open() {
        this.visible = true;
      },
      // 关掉抽屉再打开 Intercom 聊天，两个面板不重叠；消息器不可用时回退帮助中心
      openChatNow() {
        this.visible = false;
        if (!openChat()) {
          this.$message.warning(this.$t("support.chatUnavailable"));
          window.open(HELP_CENTER, "_blank", "noopener");
        }
      },
      // 应用内打开帮助空间（消息器展示全部指南；被拦截时回退网页）
      openGuides() {
        if (window.Intercom) {
          try {
            window.Intercom("trackEvent", "help_center_opened");
          } catch (e) {
            /* ignore */
          }
        }
        this.visible = false;
        showHelpSpace();
      },
      // 应用内打开指定文章
      openArticle(g) {
        this.visible = false;
        showArticle(g.articleId, g.url);
      },
      // 帮助中心站内搜索（消息器无带词搜索 API，走 /en/?q= 网页）
      searchGuides() {
        const q = (this.guideQuery || "").trim();
        window.open(q ? HELP_CENTER + "?q=" + encodeURIComponent(q) : HELP_CENTER, "_blank", "noopener");
      }
    }
  };
</script>

<style scoped lang="scss">
  .support-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--vtm-bg);
  }
  .support-panel__top {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 18px;
    background: var(--vtm-navy);
    color: #fff;
    flex-shrink: 0;
  }
  .support-panel__close {
    border: none;
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    width: 28px;
    height: 28px;
    border-radius: 7px;
    cursor: pointer;
    flex-shrink: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.22);
    }
  }
  .support-panel__title {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }
  .support-panel__title-main {
    font-family: var(--vtm-display);
    font-size: 18px;
    font-weight: 600;
  }
  .support-panel__title-sub {
    font-size: 12px;
    color: #b9c6d3;
  }
  .support-panel__body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }

  /* 支持时间与联系方式 */
  .support-hours {
    margin-bottom: 14px;
    padding: 14px;
    border-radius: var(--vtm-r-md);
    background: var(--vtm-mint-soft);
  }
  .support-hours__title {
    margin-bottom: 8px;
    font-family: var(--vtm-display);
    font-size: 13.5px;
    font-weight: 600;
    color: var(--vtm-heading);
  }
  .support-hours__line {
    margin-bottom: 4px;
    font-size: 12.5px;
    color: var(--vtm-ink-2);

    i {
      margin-right: 6px;
      color: var(--vtm-mint-ink);
    }

    a {
      color: var(--vtm-mint-ink);
      font-weight: 600;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .support-opt {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 14px;
    margin-bottom: 10px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    background: var(--vtm-surface);
    cursor: pointer;
    text-align: left;
    transition: border-color var(--vtm-speed) ease, box-shadow var(--vtm-speed) ease, transform var(--vtm-speed) ease;

    &:hover {
      border-color: var(--vtm-mint-dim);
      box-shadow: var(--vtm-e1);
      transform: translateY(-1px);
    }
  }
  .support-opt__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    border-radius: 10px;
    font-size: 19px;
  }
  .support-opt__icon--chat {
    background: var(--vtm-mint-soft);
    color: var(--vtm-mint-ink);
  }
  .support-opt__icon--guides {
    background: var(--vtm-info-soft);
    color: var(--vtm-info);
  }
  .support-opt__icon--feedback {
    background: var(--vtm-mint-soft);
    color: var(--vtm-mint-ink);
  }
  .support-opt__icon--requests {
    background: var(--vtm-info-soft);
    color: var(--vtm-info);
  }
  .support-opt__text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .support-opt__title {
    font-size: 13.5px;
    font-weight: 600;
    color: var(--vtm-heading);
  }
  .support-opt__sub {
    font-size: 12px;
    color: var(--vtm-ink-3);
  }
  .support-opt__chev {
    color: var(--vtm-ink-3);
    flex-shrink: 0;
  }

  /* 帮助中心：搜索 + 常用指南深链 */
  .support-guides {
    margin: -4px 0 12px;
    padding: 12px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    background: var(--vtm-surface);
  }
  .support-guides__label {
    margin: 12px 2px 4px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: var(--vtm-ink-3);
  }
  .support-guides__link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 4px;
    border-bottom: 1px solid var(--vtm-line);
    font-size: 12.5px;
    color: var(--vtm-ink);
    text-decoration: none;
    transition: color var(--vtm-speed) ease;

    &:last-child {
      border-bottom: none;
      padding-bottom: 2px;
    }
    > i:first-child {
      color: var(--vtm-info);
      flex-shrink: 0;
    }
    > i:last-child {
      margin-left: auto;
      color: var(--vtm-ink-3);
      font-size: 11px;
      flex-shrink: 0;
    }
    &:hover {
      color: var(--vtm-mint-ink);

      > i:last-child {
        color: var(--vtm-mint-ink);
      }
    }
  }
  .support-guides__link-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .support-note {
    margin-top: 6px;
    padding: 10px 12px;
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-well);
    font-size: 12px;
    color: var(--vtm-ink-3);

    i {
      margin-right: 5px;
    }
  }
</style>
